import { Transforms } from 'slate';

import { ELEMENT_BORDER_SHADING } from '../defaults';
import { BorderShadingColorDefinition } from '../types';
import { unwrapBorderShading } from './addBorderShading';

export const removeBorderShadingBackgroundColor = (editor) => {
  unwrapBorderShading(editor);
};

export const setBorderShadingBackgroundColor = (editor, color: BorderShadingColorDefinition) => {
  Transforms.setNodes(
    editor,
    {
      colorKey: color.key,
    },
    {
      match: (node: any) => ELEMENT_BORDER_SHADING === node.type,
    }
  );
};
